import styled, { css, keyframes } from "styled-components";

const progressBorderAnimation = keyframes`
  to {
    stroke-dashoffset: 0;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const Label = styled.span`
  border-radius: 30px;
  font-family: inherit;
  color: ${({ theme }) => theme.colors.neutral00};
  font-size: 14px;
  transition: color 0.2s ease-in-out;
  line-height: 20px;
`;

export const StyledButton = styled.button<{
  $isActive: boolean;
  $playbackTime: number;
  $variant: "primary" | "secondary";
  $isAnimationActive?: boolean;
}>`
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 30px;
  border: none;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.25);
  cursor: pointer;
  display: flex;
  gap: 4px;
  height: 32px;
  justify-content: center;
  padding: 0 16px;
  position: relative;
  backdrop-filter: blur(7.5px);

  &:hover {
    ${Label} {
      color: ${({ theme, $variant }) =>
        $variant === "primary"
          ? theme.colors.neutral00
          : theme.colors.neutral11};
    }
  }

  #progress-animation-svg {
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }

  ${({ $variant }) =>
    $variant === "secondary" &&
    css`
      background: transparent;
      box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.neutral06};

      ${Label} {
        color: ${({ theme }) => theme.colors.neutral08};
      }

      ${IconWrapper} svg {
        color: ${({ theme }) => theme.colors.neutral08};
      }
    `}

  ${({ $isActive, $playbackTime, $variant, theme }) =>
    $isActive &&
    $playbackTime &&
    css`
      pointer-events: none;

      ${Label} {
        color: ${$variant === "primary"
          ? theme.colors.neutral00
          : theme.colors.ublue06} !important;
      }

      ${IconWrapper} svg {
        color: ${$variant === "primary"
          ? theme.colors.neutral00
          : theme.colors.ublue06};
      }
    `}

    ${({ $isAnimationActive, $isActive, $playbackTime, $variant, theme }) =>
    $isAnimationActive &&
    $isActive &&
    css`
      #progress-animation-svg {
        opacity: 1;
      }

      rect {
        animation: ${progressBorderAnimation} ${$playbackTime}s linear both;
        stroke: ${$variant === "primary"
          ? theme.colors.neutral04
          : theme.colors.ublue06};
      }
    `}
`;
